import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { Button } from "@/shared/ui";
import { ClothItem, PropItem } from "@/domains/createCharacter/constants/general.ts";
import {
  hatsSelector,
  legsSelector,
  prevStep,
  shoesSelector,
  topsSelector,
} from "@/domains/createCharacter/slice";
import useChangeClothes from "@/domains/createCharacter/hooks/useChangeClothes";
import useCreateCharacter from "@/domains/createCharacter/hooks/useCreateCharacter";
import CreateCharacterScrollArea from "@/domains/createCharacter/components/CreateCharacterScrollArea";
import CreateCharacterStepHeader from "@/domains/createCharacter/components/CreateCharacterStepHeader.tsx";
import CreateCharacterVariantSelect from "@/domains/createCharacter/components/CreateCharacterVariantSelect";

export default function CreateCharacterClothesContainer() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { onChangeProps, onChangeCloth, randomizeAll, config } = useChangeClothes();
  const hats = useAppSelector(hatsSelector);
  const tops = useAppSelector(topsSelector);
  const legs = useAppSelector(legsSelector);
  const shoes = useAppSelector(shoesSelector);
  const { createCharacter, isPending } = useCreateCharacter();

  return (
    <>
      <CreateCharacterStepHeader title="Одежда" onRandom={randomizeAll} />
      <CreateCharacterScrollArea>
        <CreateCharacterVariantSelect
          label={t(`customization:hats.title`)}
          valueTitle={(value) =>
            config.hats.find((item) => item.drawableId === value)?.drawableId || "Нет"
          }
          value={hats.drawableId}
          valueDefault={config.hats[0].drawableId}
          variants={config.hats.map((item: PropItem) => item.drawableId)}
          onChange={(value) => onChangeProps({ ...hats, drawableId: Number(value) })}
        />
        <CreateCharacterVariantSelect
          label={t(`customization:tops.title`)}
          valueTitle={(value) =>
            config.tops.find((item) => item.drawableId === value)?.drawableId || "Нет"
          }
          value={tops.drawableId}
          valueDefault={config.tops[0].drawableId}
          variants={config.tops.map((item: ClothItem) => item.drawableId)}
          onChange={(value) => onChangeCloth({ ...tops, drawableId: Number(value) })}
        />
        <CreateCharacterVariantSelect
          label={t(`customization:legs.title`)}
          valueTitle={(value) =>
            config.legs.find((item) => item.drawableId === value)?.drawableId || "Нет"
          }
          value={legs.drawableId}
          valueDefault={config.legs[0].drawableId}
          variants={config.legs.map((item: ClothItem) => item.drawableId)}
          onChange={(value) => onChangeCloth({ ...legs, drawableId: Number(value) })}
        />
        <CreateCharacterVariantSelect
          label={t(`customization:shoes.title`)}
          valueTitle={(value) =>
            config.shoes.find((item) => item.drawableId === value)?.drawableId || "Нет"
          }
          value={shoes.drawableId}
          valueDefault={config.shoes[0].drawableId}
          variants={config.shoes.map((item: ClothItem) => item.drawableId)}
          onChange={(value) => onChangeCloth({ ...shoes, drawableId: Number(value) })}
        />
      </CreateCharacterScrollArea>
      <div className="grid grid-cols-2 items-center gap-2.5 pt-2 mt-auto">
        <Button
          variant="solid-surface-gradient"
          onClick={() => dispatch(prevStep())}
          disabled={isPending}
        >
          Назад
        </Button>
        <Button onClick={createCharacter} disabled={isPending} loading={isPending}>
          Далее
        </Button>
      </div>
    </>
  );
}
